import { toLocalCalendarDate } from './toLocalCalendarDate';
import type { DemandDefinition } from './types/DemandDefinition';
import type { DemandDefinitionState } from './types/DemandDefinitionState';

export const toDemandDefinitionState = (definition: DemandDefinition): DemandDefinitionState => ({
    adjustments: definition.input.adjustments,
    fleetChanges: definition.input.fleetChanges ?? [],
    leavingVessels: definition.input.leavingVessels ?? [],
    customerGroupId: definition.groupId,
    excludedCompanyIds: definition.input.excludedCompanyIds,
    excludedProductCategories: definition.input.excludedProductCategories,
    excludedProductKeys: definition.input.excludedProductKeys ?? [],
    internalNotes: definition.internalNotes ?? '',
    name: definition.name,
    reference: definition.reference ?? '',
    referencePeriodFrom: toLocalCalendarDate(definition.input.referencePeriod.from),
    referencePeriodTo: toLocalCalendarDate(definition.input.referencePeriod.to),
});
